import React from "react";
import { formatNumber } from "./financialUtils";

export default function FacturasTable({ facturas = [] }) {
  return (
    <div className="card admin-section-card mt-3">
      <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
        <div>
          <h6 className="mb-0">Facturas Recientes</h6>
          <small className="text-muted">Estado SRI y pago</small>
        </div>
        <span className="dashboard-chip">
          <i className="bi bi-receipt me-1" />
          {facturas.length}
        </span>
      </div>
      <div className="table-responsive">
        <table className="table align-middle mb-0">
          <thead>
            <tr>
              <th>Numero</th>
              <th>Cliente</th>
              <th className="text-end">Total</th>
              <th>Estado SRI</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            {facturas.length ? (
              facturas.map((f) => (
                <tr key={f.id}>
                  <td>{f.numero}</td>
                  <td>{f.cliente}</td>
                  <td className="text-end">{formatNumber(f.total, true)}</td>
                  <td>{f.estado}</td>
                  <td>{f.fecha}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center text-muted py-3">
                  Sin facturas recientes
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
